import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth';

/**
 * Datenschutzerklärung nach Art. 13 DSGVO. Bewusst auch ohne Anmeldung
 * erreichbar: Die Information muss vorliegen, bevor jemand bei der
 * Registrierung Daten angibt.
 */
export function PrivacyPage() {
  const { t } = useTranslation();
  const { privacyContact } = useAuth();
  const hasContact = Boolean(privacyContact.name || privacyContact.email);

  return (
    <div className="container page">
      <div className="eyebrow">{t('nav.privacy')}</div>
      <h1>{t('privacy.title')}</h1>
      <p className="muted">{t('privacy.intro')}</p>

      <h2>{t('privacy.controller')}</h2>
      {hasContact ? (
        <p>
          {privacyContact.name}
          {privacyContact.address && (
            <>
              <br />
              {privacyContact.address}
            </>
          )}
          <br />
          <a href={`mailto:${privacyContact.email}`}>{privacyContact.email}</a>
        </p>
      ) : (
        <p className="muted">{t('privacy.notConfigured')}</p>
      )}

      <h2>{t('privacy.dataTitle')}</h2>
      <ul>
        <li>{t('privacy.dataAccount')}</li>
        <li>{t('privacy.dataGame')}</li>
        <li>{t('privacy.dataCookies')}</li>
        <li>{t('privacy.dataLogs')}</li>
      </ul>

      <h2>{t('privacy.purposeTitle')}</h2>
      <ul>
        <li>{t('privacy.purposeContract')}</li>
        <li>{t('privacy.purposeLegitimate')}</li>
      </ul>

      <h2>{t('privacy.recipientsTitle')}</h2>
      <ul>
        <li>{t('privacy.recipientsHosting')}</li>
        <li>{t('privacy.recipientsMap')}</li>
        <li>{t('privacy.recipientsFlights')}</li>
      </ul>

      <h2>{t('privacy.retentionTitle')}</h2>
      <p>{t('privacy.retention')}</p>

      <h2>{t('privacy.rightsTitle')}</h2>
      <p>{t('privacy.rights')}</p>
      <p>{t('privacy.rightsContact')}</p>

      <h2>{t('privacy.noBannerTitle')}</h2>
      <p>{t('privacy.noBanner')}</p>
    </div>
  );
}
